function loadScr(url) {
  var s = document.createElement('script');
  s.type = 'text/javascript';
  s.async = true;
  s.src = url;
  //var x = document.getElementsByTagName('head')[0];
  document.body.appendChild(s);
}
(function() {
	'use strict';

	function init(){
		jQuery('img.svg').each(function(i) {
			var $img = jQuery(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');

			jQuery.get(imgURL, function(data) {
				var $svg = jQuery(data).find('svg');
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}
				$svg = $svg.removeAttr('xmlns:a');
				$img.replaceWith($svg);
			}, 'xml');
		});

		$('.web-wrapper').each(function() {
			$('body').removeClass('menu-open');
			var t 		= $(this),
				head 	= $('#header'),
				pnav 	= $('.page-nav'),
				headH 	= 80,
				pnavH 	= pnav.height();

			if(head.length > 0 && pnav.length > 0) {
				t.css('padding-top', headH + pnavH);
				// pnav.css('top', headH);
			} else {
				t.css('padding-top', headH);
			}

		});

    $('select.gfield_select').addClass('select-control');

		$('select.select-control').selectpicker({
			size: 4,
			width: '100%'
		});

		// run main function
		setTimeout(func, 500);

	}// end of init()

	function func(){

		$('.lang').each(function(){
			var t = $(this),
				li = t.find('li'),
				active = t.find('.active');

			active.click(function(e){
				e.preventDefault();
				t.addClass('show');
				e.stopPropagation()
			})
			$(document).on('click', function(e) {
    			if ($(e.target).is(active) === false) {
      				t.removeClass('show');
    			}
  			});
		})


		var myWave = $('.top_wave').wavify({
			height: 60,
			bones: 2,
			amplitude: 60,
			color: 'rgba(242, 251, 255, 1)',
			speed: .15
		});

		var myWave = $('.bot_wave').wavify({
			height: 60,
			bones: 2,
			amplitude: 60,
			color: 'rgba(242, 251, 255, 1)',
			speed: .15
		});
		// $('#bot_wave').css('transform','scaleY(-1)')

		$.fn.rupiah = function() {
			return this.each(function() {
				var v = $(this).val().split(',').join(''),
				f = v.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
				$(this).val(f);
			})
		}

		$('.currency').each(function() {
			$(this).keyup(function() {
				// $(this).rupiah();
				$(this).maskMoney();
			});
			$(this).maskMoney();
		});



		// mobile menu toggle
		$('.menu-icon').click(function(){
			$('body').toggleClass('menu-open');
		})
		// $('body').addClass('menu-open');

		//fixed menu
		var ct = 0;
		var header = $('#header'),
			pnav = $('.page-nav'),
			th = header.offset().top,
			hh = header.height(),
			hs = th + hh;

			if($('.back-to-top').length == 0){
				var html = "<a class='back-to-top h'><i class='fa fa-angle-up'></i></a>";
				jQuery('body').append(html);
				jQuery('.back-to-top').on('click',function(){
						jQuery("html, body").animate({ scrollTop: 0 },'slow');
				});
			}

		$(window).scroll(function() {
			$('header').each(function() {
				var top = $(window).scrollTop(),
					h = $(window).height(),
					half = h / 4,
					header = $('#header'),
					pnav = $('.page-nav');

				if (top > half) {
					header.addClass('fixed');
					pnav.addClass('fixed');
					// pnav.css('top', hh - 20);
				} else {
					header.removeClass('fixed');
					pnav.removeClass('fixed');
					// pnav.css('top', hh);
				}
				ct = top;
				if (top > half) {
					jQuery('.back-to-top').removeClass('h');
				} else {
						jQuery('.back-to-top').addClass('h');
				}
			});
		});

		if ($(window).scrollTop() > 100) {
			header.addClass('fixed');
		}

		// $('.page-nav').find('a').each(function(e) {
		// 	var urlc = $(this).attr('href').split('#');

		// 	if($('#'+urlc[1]).length > 0){
		// 		$(this).click(function(e){
		// 			e.preventDefault();
		// 			var hh = $('header').height(),
		// 				tt = $('#'+urlc[1]).offset().top - 80;
		// 			$('html, body').animate({
		// 				scrollTop: tt
		// 			}, 500);
		// 		});
		// 	}else{
		// 	  var href = $(this).attr('href').split('#'),
		// 		  html = href[0],
		// 		  hash = '#'+href[1];
		// 	  $(this).attr('href',html).attr('data-hash',hash);
		// 	}
		// });

		// Sub Menu Active state DEV
		$(document).scroll(function() {
			var cutoff = $(window).scrollTop() + 200;

			$('section').each(function(){
					if($(this).offset().top + $(this).height() > cutoff){
							$('section').removeClass('current');
							$(this).addClass('current');
						var ids = $(this).attr('id');

						$('body').find('.sub-menu li').first().addClass('active');
							$('body').find('.sub-menu').find('a').each(function(e) {
								var href = $(this).attr('href').split('#');
								var hash = $(this).attr('data-hash');
								var dh = href[1];
								if(ids == dh){
									$('body').find('.sub-menu li').removeClass('active');
									$(this).parent().addClass('active');
								};
								if(hash == "#undefined" && $(this).attr('aria-current').length > 1){
									$('body').find('.sub-menu li').removeClass('active');
								}
								// else if(hash.length > 1 && $(this).attr('aria-current') == "page"){
								// 	$('body').find('.sub-menu li').removeClass('active');
								// 	$(this).parent().addClass('active');
								// };
							});

							return false; // stops the iteration after the first one on screen
					}
			});
		});
	// Sub Menu Active state Proto
		$(document).scroll(function() {
			var cutoff = $(window).scrollTop() + 200;

			$('section').each(function(){
					if($(this).offset().top + $(this).height() > cutoff){
							$('section').removeClass('current');
							$(this).addClass('current');
						var ids = $(this).attr('id');

						$('body').find('.page-nav li').first().addClass('active');
							$('body').find('.page-nav').find('a').each(function(e) {
								var href = $(this).attr('href').split('#');
								var dh = href[1];
								if(ids == dh){
									$('body').find('.page-nav li').removeClass('active');
									$(this).parent().addClass('active');
								}
								var href = $(this).attr('href').split('#'),
								html = href[0],
								hash = '#'+href[1],
								ar = $(this).attr('aria-current');
								$(this).attr('data-hash',hash);
								if($(this).attr('data-hash') == "#undefined"){
									$(this).parent().removeClass('active');
								}
								if(ar == "page"){
									$(this).parent().addClass('active');
								}
							});


							return false; // stops the iteration after the first one on screen
					}
			});
		});

		$('.has-sub.nm').each(function(){
			var t = $(this),
					li = t.find('li');
			li.each(function () {
				$(this).removeClass('active');
			})
		});

		// // For Staging-dev Sub Menu
		// $('.sub-menu').find('a').each(function(e) {
		// 	var urlc = $(this).attr('href').split('#');

		// 	if($('#'+urlc[1]).length > 0){

		// 	  $(this).click(function(e){
		// 		e.preventDefault();
		// 		var hh = $('header').height(),
		// 			tt = $('#'+urlc[1]).offset().top - 80;
		// 		// setTimeout(function(){ alert("Hello"); }, 10);
		// 		$('html, body').animate({
		// 			scrollTop: tt
		// 		}, 500);
		// 	  })

		// 	}else{
		// 	  var href = $(this).attr('href').split('#'),
		// 		  html = href[0],
		// 		  hash = '#'+href[1];
		// 	  $(this).attr('href',html).attr('data-hash',hash);
		// 	}
		// })

		// Sub Menu
		$(".main-menu").each(function(){
			var t = $(this),
					li = t.find('ul li');
			li.each(function(){
				$(this).mouseover(function() {
					var nam = $(this).attr('data-mn'),
							pg = $('body').find('.page-nav'),
							ul = pg.find('ul'),
							mn = pg.find('ul[name="'+nam+'"]');
					// console.log(nam);
					$('.current-menu-item').addClass('curr-raw');
					$('.current_page_item').addClass('curr-raw');
					$(this).siblings().removeClass('current-menu-item current_page_item');
					$(this).addClass('hover');
				})
				$(this).mouseout(function() {
					t.find('.curr-raw').addClass('current-menu-item current_page_item');
					$(this).removeClass('hover');
				})
			})
		});

		// SLIDER

		$('.slider').each(function() {
			var t = $(this),
				item = t.attr('data-items') ? parseInt(t.attr('data-items')) : 1,
				navs = t.attr('data-nav') && t.attr('data-nav') == "yes" ? true : false,
				centers = t.attr('data-center') && t.attr('data-center') == "yes" ? true : false,
				dot = t.attr('data-dot') && t.attr('data-dot') == "no" ? false : true,
				loops = t.attr('data-loop') && t.attr('data-loop') == "no" ? false : true,
				itemtab = item > 3 ? 3 : item,
				itemltab = item > 4 ? 4 : item,
				aw = t.attr('data-width') && t.attr('data-width') == "fix" ? false : true,
				fade = t.attr('data-fade') && t.attr('data-fade') == "yes" ? 'fadeOut' : false,
				slide = t.attr('data-slide') ? t.attr('data-slide') : 1,
				child = t.children().length;
			// console.log(fade);
			if (child >= 0) {
				t.addClass('owl-carousel').each(function() {
					var t = $(this);
					t.owlCarousel({
						loop: loops,
						dots: dot,
						nav: navs,
						navText: ["<span class='icon far fa-chevron-left'></span>", "<span class='icon far fa-chevron-right'></span>"],
						autoplay: true,
						autoplayTimeout: 10000,
						autoplaySpeed: 900,
						navSpeed: 900,
						dotsSpeed: 900,
						center: centers,
						animateOut: fade,
						slideBy: slide,
						autoHeight: true,
						responsive: {
							0: {
								items: 1
							},
							768: {
								items: itemtab
							},
							992: {
								items: itemltab
							},
							1200: {
								items: item
							}
						}
					})
				})
			} else {
				t.addClass('no-slider');
				$(window).resize(function() {
					res(t)
				});

			}
		});// end of slider

		function slidermobile() {
			$('.slider-xs').each(function(){
				var w = $(window).width(),
					slider = $(this),
					nitem = slider.children().length;
				// console.log(nitem);
				if (w < 1026 && nitem > 4 || w < 426) {
					slider.addClass('owl-carousel').removeClass('ns');
					slider.each(function() {
						var t = $(this),
							item = t.attr('data-items') ? t.attr('data-items') : 1,
							navs = t.attr('data-nav') && t.attr('data-nav') == "yes" ? true : false,
							dot = navs ? false : true,
							loops = t.attr('data-loop') && t.attr('data-loop') == "no" ? false : true,
							itemtab = item > 3 ? 3 : item,
							time = t.attr('data-timeout') ? t.attr('data-timeout') : 4000,
							itemltab = item > 4 ? 4 : item;

						t.owlCarousel({
							loop: loops,
							dots: true,
							nav: navs,
							autoplay: true,
							autoHeight: true,
							autoplayTimeout: time,
							autoplaySpeed: 800,
							responsive: {
								0: {
									items: item
								},
								1024: {
									items: 4
								},
							}
						})
					})

				} else {
					slider.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
					slider.find('.owl-stage-outer').children().unwrap();
				}
			})
		}slidermobile(); // end of slider mobile

    $('#testimonial_slider').find('.row.no-gutters').each(function(i){
      $(this).attr('data-index',i+1);
    })

		$('#testimonial_slider').addClass('owl-carousel').each(function() {
			var t = $(this);
			t.owlCarousel({
				items: 1,
				loop: true,
				dots: true,
				nav: false,
				// navText: ["<span class='icon far fa-chevron-left'></span>", "<span class='icon far fa-chevron-right'></span>"],
				autoplay: true,
				autoHeight: true,
				autoplayTimeout: 10000,
				autoplaySpeed: 900,
				navSpeed: 900,
				dotsSpeed: 900,
				onInitialized  : counter, //When the plugin has initialized.
				onTranslated : counter//When the translation of the stage has finished.
			})
			t.find('.owl-prev').after('<div class="counter" id="ts_counter"></div>');
		})

		function counter(event) {
      // console.log(event);
			var element   = event.target;         // DOM element, in this example .owl-carousel
			var items     = event.item.count; // Number of items
			var index = $('.owl-item.active').find('.row.no-gutters').data('index');

			$('#ts_counter').html("0"+index+" of "+"0"+items)
		}

		// Select all links with hashes
		$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function(event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				var hed = $('body').find('.main-menu');
						hh = hed.height();
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function() {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});

		// to top right away
		if ( window.location.hash ) scroll(0,0);
		// void some browsers issue
		setTimeout( function() { scroll(0,0); }, 1);

		$(function() {

			// your current click function
			$('.scroll').on('click', function(e) {
					var hed = $('body').find('.main-menu');
					hh = hed.height();
					e.preventDefault();
					$('html, body').animate({
							scrollTop: $($(this).attr('href')).offset().top - hh  + 'px'
					}, 1000);
			});

			// *only* if we have anchor on the url
			if(window.location.hash) {
					// smooth scroll to the anchor id
					var hed = $('body').find('.main-menu');
							hh = hed.height();
					setTimeout(function() {
						$('html, body').animate({
							scrollTop: $(window.location.hash).offset().top - hh + 'px'
						}, 1000);
					}, 3000);
			}

		});


    function gform_style() {
      $('.gform_wrapper').each(function() {
        $(this).find('input[type="text"],textarea,select').each(function() {
          var t = $(this),
            li = t.closest('li.gfield');

          t.addClass('form-control').removeClass('medium');
          li.removeClass('form-control').addClass('form-group');
          li.find('label.gfield_label').addClass('placeholder').removeClass('gfield_label');
        })

        $(this).find('input[type="checkbox"]').each(function() {
          var t = $(this),
              li = t.closest('li.gfield'),
              par = $(this).parent(),label = par.find('label');;

          li.addClass('form-group mb-30 list');
          par.addClass('custom-control custom-checkbox');
          label.addClass('custom-control-label');
          t.addClass('custom-control-input');



        })

        $(this).find('ul.gfield_checkbox').removeClass('gfield_checkbox').addClass('option-list');
        $(this).find('form').addClass('custom-form');
        $(this).find(':submit').addClass('btn btn-primary');
        $(this).find('.gform_footer').addClass('form-action text-right');
        $('.form-register .gform_footer').addClass('text-center').removeClass('text-right');
        $('.contact-form #input_1_6').addClass('number');
        $('.form-register #input_1_5').addClass('number');

      })
    }

    gform_style();

    $(document).on('gform_post_render', function() {
      $('select.gfield_select').addClass('select-control').each(function() {
        $(this).selectpicker({
          style: 'select-control',
          size: 4
        });
      });
      gform_style();




    });

    //input number
    $("body").find('input.number').keydown(function(e) {
      if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
        (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode >= 35 && e.keyCode <= 40)) {
        return;
      }
      if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
        e.preventDefault();
      }
    });

	}// end of func()


	function loadimage() {
		$('.lazyload').each(function() {
			var t = $(this),
				bg = t.data('bg'),
				img = $('<img>');

			img.attr('src', bg);

			img.imagesLoaded().done(function(instance) {
				t.css('background-image', 'url("' + bg + '")');
			})
		});
	}// end of loadimage()


	// jquery History for animation transition
	$(document).ready(function() {

		$('body').addClass('ready');

		$('body').find('.sub-menu').find('a').each(function(e) {
			var href = $(this).attr('href').split('#'),
			html = href[0],
			hash = '#'+href[1],
			ar = $(this).attr('aria-current');
			$(this).attr('data-hash',hash);
			if($(this).attr('data-hash') == "#undefined"){
				$(this).parents('.menu-item-has-children').addClass('sub-menu-media');
				$(this).parent().removeClass('active');
			}
			if(ar == "page"){
				$(this).parent().addClass('active-sub');
			}
		});

		var wt = $(window).scrollTop();

		function animation() {
			$(".animate").each(function() {
				var bottom_of_object = $(this).offset().top + 10;
				var bottom_of_window = $(window).scrollTop() + $(window).height();

				if (bottom_of_window > bottom_of_object) {
					$(this).addClass('animate-in');
				} else if (bottom_of_object < 100) {
					$(this).addClass('animate-in');
				}
			})
		}// end of animation()

		// pre loading
		$('#wrap').addClass('loading');
		init();
		setTimeout(function(){
			$('#wrap').addClass('opened').removeClass('loading');
			setTimeout(function() {
				$("html, body").animate({
					// scrollTop: parseInt(wt)+"px"
				}, 'slow');
			}, 1000);
			setTimeout(function() {
				$('#header').addClass('fade-in');
			}, 1500);
			setTimeout(function() {
				$('.page-nav').addClass('fade-in');
			}, 2000);
		},2500)

		setTimeout(function() {
			animation();
		},3500);

		// RUN JQUERY HISTORY
		(function($, History, undefined) {
			if (!History.enabled) {
				return false;
			}
			var $wrap = $("#page"),
				box = $('#wrap'),
				hash = "";
			var btn;
			$('body').on("click", 'a[href]:not([target="_blank"]):not([href^="#"]):not([href^="tel:"]):not([href^="mailto:"]):not([data-lity]):not([data])', function(event) {

				event.preventDefault();
				$('body').removeClass('open');
				$('body').removeClass('modal-open');
				$('body').removeClass('menu-open');

				if (window.location === this.href) {
					return;
				}
				if($(this).data('hash')){
				  hash = $(this).data('hash');
				}


				var pageTitle = (this.title) ? this.title : this.textContent;
				pageTitle = "Indonesia Indah Foundation";
				History.pushState(null, pageTitle, this.href);

			});

			History.Adapter.bind(window, "statechange", function() {

				$('body').removeClass('open');
				$('body').removeClass('menu-open');
				$('body').removeClass('modal-open');
				$('.modal-backdrop').remove();

				var state = History.getState();
				$.get(state.url, function(res) {
					box.removeClass('opened-page').addClass('loading-page');
					$('.back-to-top').addClass('h');
					setTimeout(function() {
						setTimeout(function() {
							$("html, body").animate({
								scrollTop: 0 + "px"
							}, 'slow');
						}, 1000);
						box.addClass('process');
						var wrp = $(res).find("#page").eq(0),
							   html = wrp.html(),
                nf = $(res).find('.gform_wrapper').length;
            // if (nf > 0) {
            //   location.reload();
            // }

						setTimeout(function() {
							$wrap
								.html(html)
								.promise()
								.done(function(res) {
									setTimeout(function() {
										box.addClass('opened-page').removeClass('loading-page process');

										init();
										loadimage();
										animation();

										if(hash !=""){
											var tt = $(hash).offset().top - $('header').height();
											$('html, body').animate({
												scrollTop: tt
											}, 500);
											hash = "";
										}
									}, 500)
                  $('script[src*="/wp-content/plugins/"]').each(function(i) {
                    var t = $(this),
                      src = t.attr('src');
                    t.remove();
                    loadScr(src);

                  })
									if (typeof ga === "function" && res.length !== 0) { // Make sure the new content is added, and the 'ga()' method is available.
										ga('set', {
											page: window.location.pathname,
											title: state.title
										});
										ga('send', 'pageview');
									}
								});
						}, 2000);
					}, 100)
				});
			});

		})
		// (jQuery, window.History);


		// RUN FUNCTION ON WINDOW SCROLL
		$(window).scroll(function() {
			animation();
		})
		// RUN FUNCTION ON WINDOW RESIZE
		// $(window).resize(function() {
		// 	init();
		// })

	}) // end of document ready for jqeury history

})(); // end of function()



